// @ts-nocheck
import { GraphQLResolveInfo, SelectionSetNode, FieldNode, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@graphql-mesh/utils';

import type { GetMeshOptions } from '@graphql-mesh/runtime';
import type { YamlConfig } from '@graphql-mesh/types';
import { PubSub } from '@graphql-mesh/utils';
import { DefaultLogger } from '@graphql-mesh/utils';
import MeshCache from "@graphql-mesh/cache-localforage";
import { fetch as fetchFn } from '@whatwg-node/fetch';

import { MeshResolvedSource } from '@graphql-mesh/runtime';
import { MeshTransform, MeshPlugin } from '@graphql-mesh/types';
import GraphqlHandler from "@graphql-mesh/graphql"
import BareMerger from "@graphql-mesh/merger-bare";
import { printWithCache } from '@graphql-mesh/utils';
import { createMeshHTTPHandler, MeshHTTPHandler } from '@graphql-mesh/http';
import { getMesh, ExecuteMeshFn, SubscribeMeshFn, MeshContext as BaseMeshContext, MeshInstance } from '@graphql-mesh/runtime';
import { MeshStore, FsStoreStorageAdapter } from '@graphql-mesh/store';
import { path as pathModule } from '@graphql-mesh/cross-helpers';
import { ImportFn } from '@graphql-mesh/types';
import type { TelepathyRouterTypes } from './sources/TelepathyRouter/types';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };



/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigDecimal: any;
  BigInt: any;
  Bytes: any;
};

export type AllTimeSourceData = {
  id: Scalars['String'];
  totalSentMessages: Scalars['BigInt'];
  totalSentBytes: Scalars['BigInt'];
};

export type AllTimeSourceData_filter = {
  id?: InputMaybe<Scalars['String']>;
  id_not?: InputMaybe<Scalars['String']>;
  id_gt?: InputMaybe<Scalars['String']>;
  id_lt?: InputMaybe<Scalars['String']>;
  id_gte?: InputMaybe<Scalars['String']>;
  id_lte?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<Scalars['String']>>;
  id_not_in?: InputMaybe<Array<Scalars['String']>>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_contains_nocase?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_contains_nocase?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with_nocase?: InputMaybe<Scalars['String']>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_ends_with_nocase?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  totalSentMessages?: InputMaybe<Scalars['BigInt']>;
  totalSentMessages_not?: InputMaybe<Scalars['BigInt']>;
  totalSentMessages_gt?: InputMaybe<Scalars['BigInt']>;
  totalSentMessages_lt?: InputMaybe<Scalars['BigInt']>;
  totalSentMessages_gte?: InputMaybe<Scalars['BigInt']>;
  totalSentMessages_lte?: InputMaybe<Scalars['BigInt']>;
  totalSentMessages_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalSentMessages_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalSentBytes?: InputMaybe<Scalars['BigInt']>;
  totalSentBytes_not?: InputMaybe<Scalars['BigInt']>;
  totalSentBytes_gt?: InputMaybe<Scalars['BigInt']>;
  totalSentBytes_lt?: InputMaybe<Scalars['BigInt']>;
  totalSentBytes_gte?: InputMaybe<Scalars['BigInt']>;
  totalSentBytes_lte?: InputMaybe<Scalars['BigInt']>;
  totalSentBytes_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalSentBytes_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<AllTimeSourceData_filter>>>;
  or?: InputMaybe<Array<InputMaybe<AllTimeSourceData_filter>>>;
};

export type AllTimeSourceData_orderBy =
  | 'id'
  | 'totalSentMessages'
  | 'totalSentBytes';

export type AllTimeTargetData = {
  id: Scalars['String'];
  totalReceivedMessages: Scalars['BigInt'];
  totalReceivedBytes: Scalars['BigInt'];
};

export type AllTimeTargetData_filter = {
  id?: InputMaybe<Scalars['String']>;
  id_not?: InputMaybe<Scalars['String']>;
  id_gt?: InputMaybe<Scalars['String']>;
  id_lt?: InputMaybe<Scalars['String']>;
  id_gte?: InputMaybe<Scalars['String']>;
  id_lte?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<Scalars['String']>>;
  id_not_in?: InputMaybe<Array<Scalars['String']>>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_contains_nocase?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_contains_nocase?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with_nocase?: InputMaybe<Scalars['String']>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_ends_with_nocase?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  totalReceivedMessages?: InputMaybe<Scalars['BigInt']>;
  totalReceivedMessages_not?: InputMaybe<Scalars['BigInt']>;
  totalReceivedMessages_gt?: InputMaybe<Scalars['BigInt']>;
  totalReceivedMessages_lt?: InputMaybe<Scalars['BigInt']>;
  totalReceivedMessages_gte?: InputMaybe<Scalars['BigInt']>;
  totalReceivedMessages_lte?: InputMaybe<Scalars['BigInt']>;
  totalReceivedMessages_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalReceivedMessages_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalReceivedBytes?: InputMaybe<Scalars['BigInt']>;
  totalReceivedBytes_not?: InputMaybe<Scalars['BigInt']>;
  totalReceivedBytes_gt?: InputMaybe<Scalars['BigInt']>;
  totalReceivedBytes_lt?: InputMaybe<Scalars['BigInt']>;
  totalReceivedBytes_gte?: InputMaybe<Scalars['BigInt']>;
  totalReceivedBytes_lte?: InputMaybe<Scalars['BigInt']>;
  totalReceivedBytes_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalReceivedBytes_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<AllTimeTargetData_filter>>>;
  or?: InputMaybe<Array<InputMaybe<AllTimeTargetData_filter>>>;
};

export type AllTimeTargetData_orderBy =
  | 'id'
  | 'totalReceivedMessages'
  | 'totalReceivedBytes';

export type BlockChangedFilter = {
  number_gte: Scalars['Int'];
};

export type Block_height = {
  hash?: InputMaybe<Scalars['Bytes']>;
  number?: InputMaybe<Scalars['Int']>;
  number_gte?: InputMaybe<Scalars['Int']>;
};

export type DailySourceData = {
  id: Scalars['String'];
  dailySentMessages: Scalars['BigInt'];
  dailySentBytes: Scalars['BigInt'];
};

export type DailySourceData_filter = {
  id?: InputMaybe<Scalars['String']>;
  id_not?: InputMaybe<Scalars['String']>;
  id_gt?: InputMaybe<Scalars['String']>;
  id_lt?: InputMaybe<Scalars['String']>;
  id_gte?: InputMaybe<Scalars['String']>;
  id_lte?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<Scalars['String']>>;
  id_not_in?: InputMaybe<Array<Scalars['String']>>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_contains_nocase?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_contains_nocase?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with_nocase?: InputMaybe<Scalars['String']>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_ends_with_nocase?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  dailySentMessages?: InputMaybe<Scalars['BigInt']>;
  dailySentMessages_not?: InputMaybe<Scalars['BigInt']>;
  dailySentMessages_gt?: InputMaybe<Scalars['BigInt']>;
  dailySentMessages_lt?: InputMaybe<Scalars['BigInt']>;
  dailySentMessages_gte?: InputMaybe<Scalars['BigInt']>;
  dailySentMessages_lte?: InputMaybe<Scalars['BigInt']>;
  dailySentMessages_in?: InputMaybe<Array<Scalars['BigInt']>>;
  dailySentMessages_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  dailySentBytes?: InputMaybe<Scalars['BigInt']>;
  dailySentBytes_not?: InputMaybe<Scalars['BigInt']>;
  dailySentBytes_gt?: InputMaybe<Scalars['BigInt']>;
  dailySentBytes_lt?: InputMaybe<Scalars['BigInt']>;
  dailySentBytes_gte?: InputMaybe<Scalars['BigInt']>;
  dailySentBytes_lte?: InputMaybe<Scalars['BigInt']>;
  dailySentBytes_in?: InputMaybe<Array<Scalars['BigInt']>>;
  dailySentBytes_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<DailySourceData_filter>>>;
  or?: InputMaybe<Array<InputMaybe<DailySourceData_filter>>>;
};

export type DailySourceData_orderBy =
  | 'id'
  | 'dailySentMessages'
  | 'dailySentBytes';

export type DailyTargetData = {
  id: Scalars['String'];
  dailyReceivedMessages: Scalars['BigInt'];
  dailyReceivedBytes: Scalars['BigInt'];
};

export type DailyTargetData_filter = {
  id?: InputMaybe<Scalars['String']>;
  id_not?: InputMaybe<Scalars['String']>;
  id_gt?: InputMaybe<Scalars['String']>;
  id_lt?: InputMaybe<Scalars['String']>;
  id_gte?: InputMaybe<Scalars['String']>;
  id_lte?: InputMaybe<Scalars['String']>;
  id_in?: InputMaybe<Array<Scalars['String']>>;
  id_not_in?: InputMaybe<Array<Scalars['String']>>;
  id_contains?: InputMaybe<Scalars['String']>;
  id_contains_nocase?: InputMaybe<Scalars['String']>;
  id_not_contains?: InputMaybe<Scalars['String']>;
  id_not_contains_nocase?: InputMaybe<Scalars['String']>;
  id_starts_with?: InputMaybe<Scalars['String']>;
  id_starts_with_nocase?: InputMaybe<Scalars['String']>;
  id_not_starts_with?: InputMaybe<Scalars['String']>;
  id_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  id_ends_with?: InputMaybe<Scalars['String']>;
  id_ends_with_nocase?: InputMaybe<Scalars['String']>;
  id_not_ends_with?: InputMaybe<Scalars['String']>;
  id_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  dailyReceivedMessages?: InputMaybe<Scalars['BigInt']>;
  dailyReceivedMessages_not?: InputMaybe<Scalars['BigInt']>;
  dailyReceivedMessages_gt?: InputMaybe<Scalars['BigInt']>;
  dailyReceivedMessages_lt?: InputMaybe<Scalars['BigInt']>;
  dailyReceivedMessages_gte?: InputMaybe<Scalars['BigInt']>;
  dailyReceivedMessages_lte?: InputMaybe<Scalars['BigInt']>;
  dailyReceivedMessages_in?: InputMaybe<Array<Scalars['BigInt']>>;
  dailyReceivedMessages_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  dailyReceivedBytes?: InputMaybe<Scalars['BigInt']>;
  dailyReceivedBytes_not?: InputMaybe<Scalars['BigInt']>;
  dailyReceivedBytes_gt?: InputMaybe<Scalars['BigInt']>;
  dailyReceivedBytes_lt?: InputMaybe<Scalars['BigInt']>;
  dailyReceivedBytes_gte?: InputMaybe<Scalars['BigInt']>;
  dailyReceivedBytes_lte?: InputMaybe<Scalars['BigInt']>;
  dailyReceivedBytes_in?: InputMaybe<Array<Scalars['BigInt']>>;
  dailyReceivedBytes_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<DailyTargetData_filter>>>;
  or?: InputMaybe<Array<InputMaybe<DailyTargetData_filter>>>;
};

export type DailyTargetData_orderBy =
  | 'id'
  | 'dailyReceivedMessages'
  | 'dailyReceivedBytes';

export type ExecutedMessage = {
  id: Scalars['Bytes'];
  version: Scalars['Int'];
  msgHash: Scalars['Bytes'];
  message: Scalars['Bytes'];
  messageNonce: Scalars['BigInt'];
  messageSenderChainID: Scalars['BigInt'];
  messageSender: Scalars['Bytes'];
  messageReceiverChainID: Scalars['BigInt'];
  messageReceiver: Scalars['Bytes'];
  messageData: Scalars['Bytes'];
  status: Scalars['Boolean'];
  transactionOrigin: Scalars['Bytes'];
  blockNumber: Scalars['BigInt'];
  blockTimestamp: Scalars['BigInt'];
  transactionHash: Scalars['Bytes'];
};

export type ExecutedMessage_filter = {
  id?: InputMaybe<Scalars['Bytes']>;
  id_not?: InputMaybe<Scalars['Bytes']>;
  id_gt?: InputMaybe<Scalars['Bytes']>;
  id_lt?: InputMaybe<Scalars['Bytes']>;
  id_gte?: InputMaybe<Scalars['Bytes']>;
  id_lte?: InputMaybe<Scalars['Bytes']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']>>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  id_contains?: InputMaybe<Scalars['Bytes']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']>;
  version?: InputMaybe<Scalars['Int']>;
  version_not?: InputMaybe<Scalars['Int']>;
  version_gt?: InputMaybe<Scalars['Int']>;
  version_lt?: InputMaybe<Scalars['Int']>;
  version_gte?: InputMaybe<Scalars['Int']>;
  version_lte?: InputMaybe<Scalars['Int']>;
  version_in?: InputMaybe<Array<Scalars['Int']>>;
  version_not_in?: InputMaybe<Array<Scalars['Int']>>;
  msgHash?: InputMaybe<Scalars['Bytes']>;
  msgHash_not?: InputMaybe<Scalars['Bytes']>;
  msgHash_gt?: InputMaybe<Scalars['Bytes']>;
  msgHash_lt?: InputMaybe<Scalars['Bytes']>;
  msgHash_gte?: InputMaybe<Scalars['Bytes']>;
  msgHash_lte?: InputMaybe<Scalars['Bytes']>;
  msgHash_in?: InputMaybe<Array<Scalars['Bytes']>>;
  msgHash_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  msgHash_contains?: InputMaybe<Scalars['Bytes']>;
  msgHash_not_contains?: InputMaybe<Scalars['Bytes']>;
  message?: InputMaybe<Scalars['Bytes']>;
  message_not?: InputMaybe<Scalars['Bytes']>;
  message_gt?: InputMaybe<Scalars['Bytes']>;
  message_lt?: InputMaybe<Scalars['Bytes']>;
  message_gte?: InputMaybe<Scalars['Bytes']>;
  message_lte?: InputMaybe<Scalars['Bytes']>;
  message_in?: InputMaybe<Array<Scalars['Bytes']>>;
  message_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  message_contains?: InputMaybe<Scalars['Bytes']>;
  message_not_contains?: InputMaybe<Scalars['Bytes']>;
  messageNonce?: InputMaybe<Scalars['BigInt']>;
  messageNonce_not?: InputMaybe<Scalars['BigInt']>;
  messageNonce_gt?: InputMaybe<Scalars['BigInt']>;
  messageNonce_lt?: InputMaybe<Scalars['BigInt']>;
  messageNonce_gte?: InputMaybe<Scalars['BigInt']>;
  messageNonce_lte?: InputMaybe<Scalars['BigInt']>;
  messageNonce_in?: InputMaybe<Array<Scalars['BigInt']>>;
  messageNonce_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  messageSenderChainID?: InputMaybe<Scalars['BigInt']>;
  messageSenderChainID_not?: InputMaybe<Scalars['BigInt']>;
  messageSenderChainID_gt?: InputMaybe<Scalars['BigInt']>;
  messageSenderChainID_lt?: InputMaybe<Scalars['BigInt']>;
  messageSenderChainID_gte?: InputMaybe<Scalars['BigInt']>;
  messageSenderChainID_lte?: InputMaybe<Scalars['BigInt']>;
  messageSenderChainID_in?: InputMaybe<Array<Scalars['BigInt']>>;
  messageSenderChainID_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  messageSender?: InputMaybe<Scalars['Bytes']>;
  messageSender_not?: InputMaybe<Scalars['Bytes']>;
  messageSender_gt?: InputMaybe<Scalars['Bytes']>;
  messageSender_lt?: InputMaybe<Scalars['Bytes']>;
  messageSender_gte?: InputMaybe<Scalars['Bytes']>;
  messageSender_lte?: InputMaybe<Scalars['Bytes']>;
  messageSender_in?: InputMaybe<Array<Scalars['Bytes']>>;
  messageSender_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  messageSender_contains?: InputMaybe<Scalars['Bytes']>;
  messageSender_not_contains?: InputMaybe<Scalars['Bytes']>;
  messageReceiverChainID?: InputMaybe<Scalars['BigInt']>;
  messageReceiverChainID_not?: InputMaybe<Scalars['BigInt']>;
  messageReceiverChainID_gt?: InputMaybe<Scalars['BigInt']>;
  messageReceiverChainID_lt?: InputMaybe<Scalars['BigInt']>;
  messageReceiverChainID_gte?: InputMaybe<Scalars['BigInt']>;
  messageReceiverChainID_lte?: InputMaybe<Scalars['BigInt']>;
  messageReceiverChainID_in?: InputMaybe<Array<Scalars['BigInt']>>;
  messageReceiverChainID_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  messageReceiver?: InputMaybe<Scalars['Bytes']>;
  messageReceiver_not?: InputMaybe<Scalars['Bytes']>;
  messageReceiver_gt?: InputMaybe<Scalars['Bytes']>;
  messageReceiver_lt?: InputMaybe<Scalars['Bytes']>;
  messageReceiver_gte?: InputMaybe<Scalars['Bytes']>;
  messageReceiver_lte?: InputMaybe<Scalars['Bytes']>;
  messageReceiver_in?: InputMaybe<Array<Scalars['Bytes']>>;
  messageReceiver_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  messageReceiver_contains?: InputMaybe<Scalars['Bytes']>;
  messageReceiver_not_contains?: InputMaybe<Scalars['Bytes']>;
  messageData?: InputMaybe<Scalars['Bytes']>;
  messageData_not?: InputMaybe<Scalars['Bytes']>;
  messageData_gt?: InputMaybe<Scalars['Bytes']>;
  messageData_lt?: InputMaybe<Scalars['Bytes']>;
  messageData_gte?: InputMaybe<Scalars['Bytes']>;
  messageData_lte?: InputMaybe<Scalars['Bytes']>;
  messageData_in?: InputMaybe<Array<Scalars['Bytes']>>;
  messageData_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  messageData_contains?: InputMaybe<Scalars['Bytes']>;
  messageData_not_contains?: InputMaybe<Scalars['Bytes']>;
  status?: InputMaybe<Scalars['Boolean']>;
  status_not?: InputMaybe<Scalars['Boolean']>;
  status_in?: InputMaybe<Array<Scalars['Boolean']>>;
  status_not_in?: InputMaybe<Array<Scalars['Boolean']>>;
  transactionOrigin?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_not?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_gt?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_lt?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_gte?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_lte?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionOrigin_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionOrigin_contains?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_not_contains?: InputMaybe<Scalars['Bytes']>;
  blockNumber?: InputMaybe<Scalars['BigInt']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ExecutedMessage_filter>>>;
  or?: InputMaybe<Array<InputMaybe<ExecutedMessage_filter>>>;
};

export type ExecutedMessage_orderBy =
  | 'id'
  | 'version'
  | 'msgHash'
  | 'message'
  | 'messageNonce'
  | 'messageSenderChainID'
  | 'messageSender'
  | 'messageReceiverChainID'
  | 'messageReceiver'
  | 'messageData'
  | 'status'
  | 'transactionOrigin'
  | 'blockNumber'
  | 'blockTimestamp'
  | 'transactionHash';

export type HeadUpdate = {
  id: Scalars['Bytes'];
  slot: Scalars['BigInt'];
  root: Scalars['Bytes'];
  blockNumber: Scalars['BigInt'];
  blockTimestamp: Scalars['BigInt'];
  transactionHash: Scalars['Bytes'];
  transactionOrigin: Scalars['Bytes'];
  address: Scalars['Bytes'];
  chainId: Scalars['BigInt'];
};

export type HeadUpdate_filter = {
  id?: InputMaybe<Scalars['Bytes']>;
  id_not?: InputMaybe<Scalars['Bytes']>;
  id_gt?: InputMaybe<Scalars['Bytes']>;
  id_lt?: InputMaybe<Scalars['Bytes']>;
  id_gte?: InputMaybe<Scalars['Bytes']>;
  id_lte?: InputMaybe<Scalars['Bytes']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']>>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  id_contains?: InputMaybe<Scalars['Bytes']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']>;
  slot?: InputMaybe<Scalars['BigInt']>;
  slot_not?: InputMaybe<Scalars['BigInt']>;
  slot_gt?: InputMaybe<Scalars['BigInt']>;
  slot_lt?: InputMaybe<Scalars['BigInt']>;
  slot_gte?: InputMaybe<Scalars['BigInt']>;
  slot_lte?: InputMaybe<Scalars['BigInt']>;
  slot_in?: InputMaybe<Array<Scalars['BigInt']>>;
  slot_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  root?: InputMaybe<Scalars['Bytes']>;
  root_not?: InputMaybe<Scalars['Bytes']>;
  root_gt?: InputMaybe<Scalars['Bytes']>;
  root_lt?: InputMaybe<Scalars['Bytes']>;
  root_gte?: InputMaybe<Scalars['Bytes']>;
  root_lte?: InputMaybe<Scalars['Bytes']>;
  root_in?: InputMaybe<Array<Scalars['Bytes']>>;
  root_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  root_contains?: InputMaybe<Scalars['Bytes']>;
  root_not_contains?: InputMaybe<Scalars['Bytes']>;
  blockNumber?: InputMaybe<Scalars['BigInt']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_not?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_gt?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_lt?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_gte?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_lte?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionOrigin_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionOrigin_contains?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_not_contains?: InputMaybe<Scalars['Bytes']>;
  address?: InputMaybe<Scalars['Bytes']>;
  address_not?: InputMaybe<Scalars['Bytes']>;
  address_gt?: InputMaybe<Scalars['Bytes']>;
  address_lt?: InputMaybe<Scalars['Bytes']>;
  address_gte?: InputMaybe<Scalars['Bytes']>;
  address_lte?: InputMaybe<Scalars['Bytes']>;
  address_in?: InputMaybe<Array<Scalars['Bytes']>>;
  address_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  address_contains?: InputMaybe<Scalars['Bytes']>;
  address_not_contains?: InputMaybe<Scalars['Bytes']>;
  chainId?: InputMaybe<Scalars['BigInt']>;
  chainId_not?: InputMaybe<Scalars['BigInt']>;
  chainId_gt?: InputMaybe<Scalars['BigInt']>;
  chainId_lt?: InputMaybe<Scalars['BigInt']>;
  chainId_gte?: InputMaybe<Scalars['BigInt']>;
  chainId_lte?: InputMaybe<Scalars['BigInt']>;
  chainId_in?: InputMaybe<Array<Scalars['BigInt']>>;
  chainId_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<HeadUpdate_filter>>>;
  or?: InputMaybe<Array<InputMaybe<HeadUpdate_filter>>>;
};

export type HeadUpdate_orderBy =
  | 'id'
  | 'slot'
  | 'root'
  | 'blockNumber'
  | 'blockTimestamp'
  | 'transactionHash'
  | 'transactionOrigin'
  | 'address'
  | 'chainId';

/** Defines the order direction, either ascending or descending */
export type OrderDirection =
  | 'asc'
  | 'desc';

export type Query = {
  sentMessage?: Maybe<SentMessage>;
  sentMessages: Array<SentMessage>;
  dailySourceData?: Maybe<DailySourceData>;
  dailySourceDatas: Array<DailySourceData>;
  allTimeSourceData?: Maybe<AllTimeSourceData>;
  allTimeSourceDatas: Array<AllTimeSourceData>;
  executedMessage?: Maybe<ExecutedMessage>;
  executedMessages: Array<ExecutedMessage>;
  dailyTargetData?: Maybe<DailyTargetData>;
  dailyTargetDatas: Array<DailyTargetData>;
  allTimeTargetData?: Maybe<AllTimeTargetData>;
  allTimeTargetDatas: Array<AllTimeTargetData>;
  headUpdate?: Maybe<HeadUpdate>;
  headUpdates: Array<HeadUpdate>;
  syncCommitteeUpdate?: Maybe<SyncCommitteeUpdate>;
  syncCommitteeUpdates: Array<SyncCommitteeUpdate>;
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
};


export type QuerysentMessageArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerysentMessagesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SentMessage_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<SentMessage_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerydailySourceDataArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerydailySourceDatasArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DailySourceData_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<DailySourceData_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryallTimeSourceDataArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryallTimeSourceDatasArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AllTimeSourceData_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<AllTimeSourceData_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryexecutedMessageArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryexecutedMessagesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ExecutedMessage_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<ExecutedMessage_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerydailyTargetDataArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerydailyTargetDatasArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DailyTargetData_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<DailyTargetData_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryallTimeTargetDataArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryallTimeTargetDatasArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AllTimeTargetData_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<AllTimeTargetData_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryheadUpdateArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryheadUpdatesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<HeadUpdate_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<HeadUpdate_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerysyncCommitteeUpdateArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QuerysyncCommitteeUpdatesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SyncCommitteeUpdate_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<SyncCommitteeUpdate_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Query_metaArgs = {
  block?: InputMaybe<Block_height>;
};

export type SentMessage = {
  id: Scalars['Bytes'];
  version: Scalars['Int'];
  msgHash: Scalars['Bytes'];
  message: Scalars['Bytes'];
  messageNonce: Scalars['BigInt'];
  messageSenderChainID: Scalars['BigInt'];
  messageSender: Scalars['Bytes'];
  messageReceiverChainID: Scalars['BigInt'];
  messageReceiver: Scalars['Bytes'];
  messageData: Scalars['Bytes'];
  transactionOrigin: Scalars['Bytes'];
  blockNumber: Scalars['BigInt'];
  blockTimestamp: Scalars['BigInt'];
  transactionHash: Scalars['Bytes'];
};

export type SentMessage_filter = {
  id?: InputMaybe<Scalars['Bytes']>;
  id_not?: InputMaybe<Scalars['Bytes']>;
  id_gt?: InputMaybe<Scalars['Bytes']>;
  id_lt?: InputMaybe<Scalars['Bytes']>;
  id_gte?: InputMaybe<Scalars['Bytes']>;
  id_lte?: InputMaybe<Scalars['Bytes']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']>>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  id_contains?: InputMaybe<Scalars['Bytes']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']>;
  version?: InputMaybe<Scalars['Int']>;
  version_not?: InputMaybe<Scalars['Int']>;
  version_gt?: InputMaybe<Scalars['Int']>;
  version_lt?: InputMaybe<Scalars['Int']>;
  version_gte?: InputMaybe<Scalars['Int']>;
  version_lte?: InputMaybe<Scalars['Int']>;
  version_in?: InputMaybe<Array<Scalars['Int']>>;
  version_not_in?: InputMaybe<Array<Scalars['Int']>>;
  msgHash?: InputMaybe<Scalars['Bytes']>;
  msgHash_not?: InputMaybe<Scalars['Bytes']>;
  msgHash_gt?: InputMaybe<Scalars['Bytes']>;
  msgHash_lt?: InputMaybe<Scalars['Bytes']>;
  msgHash_gte?: InputMaybe<Scalars['Bytes']>;
  msgHash_lte?: InputMaybe<Scalars['Bytes']>;
  msgHash_in?: InputMaybe<Array<Scalars['Bytes']>>;
  msgHash_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  msgHash_contains?: InputMaybe<Scalars['Bytes']>;
  msgHash_not_contains?: InputMaybe<Scalars['Bytes']>;
  message?: InputMaybe<Scalars['Bytes']>;
  message_not?: InputMaybe<Scalars['Bytes']>;
  message_gt?: InputMaybe<Scalars['Bytes']>;
  message_lt?: InputMaybe<Scalars['Bytes']>;
  message_gte?: InputMaybe<Scalars['Bytes']>;
  message_lte?: InputMaybe<Scalars['Bytes']>;
  message_in?: InputMaybe<Array<Scalars['Bytes']>>;
  message_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  message_contains?: InputMaybe<Scalars['Bytes']>;
  message_not_contains?: InputMaybe<Scalars['Bytes']>;
  messageNonce?: InputMaybe<Scalars['BigInt']>;
  messageNonce_not?: InputMaybe<Scalars['BigInt']>;
  messageNonce_gt?: InputMaybe<Scalars['BigInt']>;
  messageNonce_lt?: InputMaybe<Scalars['BigInt']>;
  messageNonce_gte?: InputMaybe<Scalars['BigInt']>;
  messageNonce_lte?: InputMaybe<Scalars['BigInt']>;
  messageNonce_in?: InputMaybe<Array<Scalars['BigInt']>>;
  messageNonce_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  messageSenderChainID?: InputMaybe<Scalars['BigInt']>;
  messageSenderChainID_not?: InputMaybe<Scalars['BigInt']>;
  messageSenderChainID_gt?: InputMaybe<Scalars['BigInt']>;
  messageSenderChainID_lt?: InputMaybe<Scalars['BigInt']>;
  messageSenderChainID_gte?: InputMaybe<Scalars['BigInt']>;
  messageSenderChainID_lte?: InputMaybe<Scalars['BigInt']>;
  messageSenderChainID_in?: InputMaybe<Array<Scalars['BigInt']>>;
  messageSenderChainID_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  messageSender?: InputMaybe<Scalars['Bytes']>;
  messageSender_not?: InputMaybe<Scalars['Bytes']>;
  messageSender_gt?: InputMaybe<Scalars['Bytes']>;
  messageSender_lt?: InputMaybe<Scalars['Bytes']>;
  messageSender_gte?: InputMaybe<Scalars['Bytes']>;
  messageSender_lte?: InputMaybe<Scalars['Bytes']>;
  messageSender_in?: InputMaybe<Array<Scalars['Bytes']>>;
  messageSender_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  messageSender_contains?: InputMaybe<Scalars['Bytes']>;
  messageSender_not_contains?: InputMaybe<Scalars['Bytes']>;
  messageReceiverChainID?: InputMaybe<Scalars['BigInt']>;
  messageReceiverChainID_not?: InputMaybe<Scalars['BigInt']>;
  messageReceiverChainID_gt?: InputMaybe<Scalars['BigInt']>;
  messageReceiverChainID_lt?: InputMaybe<Scalars['BigInt']>;
  messageReceiverChainID_gte?: InputMaybe<Scalars['BigInt']>;
  messageReceiverChainID_lte?: InputMaybe<Scalars['BigInt']>;
  messageReceiverChainID_in?: InputMaybe<Array<Scalars['BigInt']>>;
  messageReceiverChainID_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  messageReceiver?: InputMaybe<Scalars['Bytes']>;
  messageReceiver_not?: InputMaybe<Scalars['Bytes']>;
  messageReceiver_gt?: InputMaybe<Scalars['Bytes']>;
  messageReceiver_lt?: InputMaybe<Scalars['Bytes']>;
  messageReceiver_gte?: InputMaybe<Scalars['Bytes']>;
  messageReceiver_lte?: InputMaybe<Scalars['Bytes']>;
  messageReceiver_in?: InputMaybe<Array<Scalars['Bytes']>>;
  messageReceiver_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  messageReceiver_contains?: InputMaybe<Scalars['Bytes']>;
  messageReceiver_not_contains?: InputMaybe<Scalars['Bytes']>;
  messageData?: InputMaybe<Scalars['Bytes']>;
  messageData_not?: InputMaybe<Scalars['Bytes']>;
  messageData_gt?: InputMaybe<Scalars['Bytes']>;
  messageData_lt?: InputMaybe<Scalars['Bytes']>;
  messageData_gte?: InputMaybe<Scalars['Bytes']>;
  messageData_lte?: InputMaybe<Scalars['Bytes']>;
  messageData_in?: InputMaybe<Array<Scalars['Bytes']>>;
  messageData_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  messageData_contains?: InputMaybe<Scalars['Bytes']>;
  messageData_not_contains?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_not?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_gt?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_lt?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_gte?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_lte?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionOrigin_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionOrigin_contains?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_not_contains?: InputMaybe<Scalars['Bytes']>;
  blockNumber?: InputMaybe<Scalars['BigInt']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<SentMessage_filter>>>;
  or?: InputMaybe<Array<InputMaybe<SentMessage_filter>>>;
};

export type SentMessage_orderBy =
  | 'id'
  | 'version'
  | 'msgHash'
  | 'message'
  | 'messageNonce'
  | 'messageSenderChainID'
  | 'messageSender'
  | 'messageReceiverChainID'
  | 'messageReceiver'
  | 'messageData'
  | 'transactionOrigin'
  | 'blockNumber'
  | 'blockTimestamp'
  | 'transactionHash';

export type Subscription = {
  sentMessage?: Maybe<SentMessage>;
  sentMessages: Array<SentMessage>;
  dailySourceData?: Maybe<DailySourceData>;
  dailySourceDatas: Array<DailySourceData>;
  allTimeSourceData?: Maybe<AllTimeSourceData>;
  allTimeSourceDatas: Array<AllTimeSourceData>;
  executedMessage?: Maybe<ExecutedMessage>;
  executedMessages: Array<ExecutedMessage>;
  dailyTargetData?: Maybe<DailyTargetData>;
  dailyTargetDatas: Array<DailyTargetData>;
  allTimeTargetData?: Maybe<AllTimeTargetData>;
  allTimeTargetDatas: Array<AllTimeTargetData>;
  headUpdate?: Maybe<HeadUpdate>;
  headUpdates: Array<HeadUpdate>;
  syncCommitteeUpdate?: Maybe<SyncCommitteeUpdate>;
  syncCommitteeUpdates: Array<SyncCommitteeUpdate>;
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
};


export type SubscriptionsentMessageArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionsentMessagesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SentMessage_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<SentMessage_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptiondailySourceDataArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptiondailySourceDatasArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DailySourceData_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<DailySourceData_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionallTimeSourceDataArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionallTimeSourceDatasArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AllTimeSourceData_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<AllTimeSourceData_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionexecutedMessageArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionexecutedMessagesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ExecutedMessage_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<ExecutedMessage_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptiondailyTargetDataArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptiondailyTargetDatasArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<DailyTargetData_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<DailyTargetData_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionallTimeTargetDataArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionallTimeTargetDatasArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AllTimeTargetData_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<AllTimeTargetData_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionheadUpdateArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionheadUpdatesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<HeadUpdate_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<HeadUpdate_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionsyncCommitteeUpdateArgs = {
  id: Scalars['ID'];
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionsyncCommitteeUpdatesArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SyncCommitteeUpdate_orderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  where?: InputMaybe<SyncCommitteeUpdate_filter>;
  block?: InputMaybe<Block_height>;
  subgraphError?: _SubgraphErrorPolicy_;
};


export type Subscription_metaArgs = {
  block?: InputMaybe<Block_height>;
};

export type SyncCommitteeUpdate = {
  id: Scalars['Bytes'];
  period: Scalars['BigInt'];
  root: Scalars['Bytes'];
  blockNumber: Scalars['BigInt'];
  blockTimestamp: Scalars['BigInt'];
  transactionHash: Scalars['Bytes'];
  transactionOrigin: Scalars['Bytes'];
  address: Scalars['Bytes'];
  chainId: Scalars['BigInt'];
};

export type SyncCommitteeUpdate_filter = {
  id?: InputMaybe<Scalars['Bytes']>;
  id_not?: InputMaybe<Scalars['Bytes']>;
  id_gt?: InputMaybe<Scalars['Bytes']>;
  id_lt?: InputMaybe<Scalars['Bytes']>;
  id_gte?: InputMaybe<Scalars['Bytes']>;
  id_lte?: InputMaybe<Scalars['Bytes']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']>>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  id_contains?: InputMaybe<Scalars['Bytes']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']>;
  period?: InputMaybe<Scalars['BigInt']>;
  period_not?: InputMaybe<Scalars['BigInt']>;
  period_gt?: InputMaybe<Scalars['BigInt']>;
  period_lt?: InputMaybe<Scalars['BigInt']>;
  period_gte?: InputMaybe<Scalars['BigInt']>;
  period_lte?: InputMaybe<Scalars['BigInt']>;
  period_in?: InputMaybe<Array<Scalars['BigInt']>>;
  period_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  root?: InputMaybe<Scalars['Bytes']>;
  root_not?: InputMaybe<Scalars['Bytes']>;
  root_gt?: InputMaybe<Scalars['Bytes']>;
  root_lt?: InputMaybe<Scalars['Bytes']>;
  root_gte?: InputMaybe<Scalars['Bytes']>;
  root_lte?: InputMaybe<Scalars['Bytes']>;
  root_in?: InputMaybe<Array<Scalars['Bytes']>>;
  root_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  root_contains?: InputMaybe<Scalars['Bytes']>;
  root_not_contains?: InputMaybe<Scalars['Bytes']>;
  blockNumber?: InputMaybe<Scalars['BigInt']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_not?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_gt?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_lt?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_gte?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_lte?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionOrigin_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionOrigin_contains?: InputMaybe<Scalars['Bytes']>;
  transactionOrigin_not_contains?: InputMaybe<Scalars['Bytes']>;
  address?: InputMaybe<Scalars['Bytes']>;
  address_not?: InputMaybe<Scalars['Bytes']>;
  address_gt?: InputMaybe<Scalars['Bytes']>;
  address_lt?: InputMaybe<Scalars['Bytes']>;
  address_gte?: InputMaybe<Scalars['Bytes']>;
  address_lte?: InputMaybe<Scalars['Bytes']>;
  address_in?: InputMaybe<Array<Scalars['Bytes']>>;
  address_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  address_contains?: InputMaybe<Scalars['Bytes']>;
  address_not_contains?: InputMaybe<Scalars['Bytes']>;
  chainId?: InputMaybe<Scalars['BigInt']>;
  chainId_not?: InputMaybe<Scalars['BigInt']>;
  chainId_gt?: InputMaybe<Scalars['BigInt']>;
  chainId_lt?: InputMaybe<Scalars['BigInt']>;
  chainId_gte?: InputMaybe<Scalars['BigInt']>;
  chainId_lte?: InputMaybe<Scalars['BigInt']>;
  chainId_in?: InputMaybe<Array<Scalars['BigInt']>>;
  chainId_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<SyncCommitteeUpdate_filter>>>;
  or?: InputMaybe<Array<InputMaybe<SyncCommitteeUpdate_filter>>>;
};

export type SyncCommitteeUpdate_orderBy =
  | 'id'
  | 'period'
  | 'root'
  | 'blockNumber'
  | 'blockTimestamp'
  | 'transactionHash'
  | 'transactionOrigin'
  | 'address'
  | 'chainId';

export type _Block_ = {
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']>;
  /** The block number */
  number: Scalars['Int'];
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']>;
};

/** The type for the top-level _meta field */
export type _Meta_ = {
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   *
   */
  block: _Block_;
  /** The deployment ID */
  deployment: Scalars['String'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean'];
};

export type _SubgraphErrorPolicy_ =
  /** Data will be returned even if the subgraph has indexing errors */
  | 'allow'
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  | 'deny';

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type LegacyStitchingResolver<TResult, TParent, TContext, TArgs> = {
  fragment: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type NewStitchingResolver<TResult, TParent, TContext, TArgs> = {
  selectionSet: string | ((fieldNode: FieldNode) => SelectionSetNode);
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type StitchingResolver<TResult, TParent, TContext, TArgs> = LegacyStitchingResolver<TResult, TParent, TContext, TArgs> | NewStitchingResolver<TResult, TParent, TContext, TArgs>;
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | ResolverWithResolve<TResult, TParent, TContext, TArgs>
  | StitchingResolver<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  AllTimeSourceData: ResolverTypeWrapper<AllTimeSourceData>;
  AllTimeSourceData_filter: AllTimeSourceData_filter;
  AllTimeSourceData_orderBy: AllTimeSourceData_orderBy;
  AllTimeTargetData: ResolverTypeWrapper<AllTimeTargetData>;
  AllTimeTargetData_filter: AllTimeTargetData_filter;
  AllTimeTargetData_orderBy: AllTimeTargetData_orderBy;
  BigDecimal: ResolverTypeWrapper<Scalars['BigDecimal']>;
  BigInt: ResolverTypeWrapper<Scalars['BigInt']>;
  BlockChangedFilter: BlockChangedFilter;
  Block_height: Block_height;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  Bytes: ResolverTypeWrapper<Scalars['Bytes']>;
  DailySourceData: ResolverTypeWrapper<DailySourceData>;
  DailySourceData_filter: DailySourceData_filter;
  DailySourceData_orderBy: DailySourceData_orderBy;
  DailyTargetData: ResolverTypeWrapper<DailyTargetData>;
  DailyTargetData_filter: DailyTargetData_filter;
  DailyTargetData_orderBy: DailyTargetData_orderBy;
  ExecutedMessage: ResolverTypeWrapper<ExecutedMessage>;
  ExecutedMessage_filter: ExecutedMessage_filter;
  ExecutedMessage_orderBy: ExecutedMessage_orderBy;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  HeadUpdate: ResolverTypeWrapper<HeadUpdate>;
  HeadUpdate_filter: HeadUpdate_filter;
  HeadUpdate_orderBy: HeadUpdate_orderBy;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  OrderDirection: OrderDirection;
  Query: ResolverTypeWrapper<{}>;
  SentMessage: ResolverTypeWrapper<SentMessage>;
  SentMessage_filter: SentMessage_filter;
  SentMessage_orderBy: SentMessage_orderBy;
  String: ResolverTypeWrapper<Scalars['String']>;
  Subscription: ResolverTypeWrapper<{}>;
  SyncCommitteeUpdate: ResolverTypeWrapper<SyncCommitteeUpdate>;
  SyncCommitteeUpdate_filter: SyncCommitteeUpdate_filter;
  SyncCommitteeUpdate_orderBy: SyncCommitteeUpdate_orderBy;
  _Block_: ResolverTypeWrapper<_Block_>;
  _Meta_: ResolverTypeWrapper<_Meta_>;
  _SubgraphErrorPolicy_: _SubgraphErrorPolicy_;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  AllTimeSourceData: AllTimeSourceData;
  AllTimeSourceData_filter: AllTimeSourceData_filter;
  AllTimeTargetData: AllTimeTargetData;
  AllTimeTargetData_filter: AllTimeTargetData_filter;
  BigDecimal: Scalars['BigDecimal'];
  BigInt: Scalars['BigInt'];
  BlockChangedFilter: BlockChangedFilter;
  Block_height: Block_height;
  Boolean: Scalars['Boolean'];
  Bytes: Scalars['Bytes'];
  DailySourceData: DailySourceData;
  DailySourceData_filter: DailySourceData_filter;
  DailyTargetData: DailyTargetData;
  DailyTargetData_filter: DailyTargetData_filter;
  ExecutedMessage: ExecutedMessage;
  ExecutedMessage_filter: ExecutedMessage_filter;
  Float: Scalars['Float'];
  HeadUpdate: HeadUpdate;
  HeadUpdate_filter: HeadUpdate_filter;
  ID: Scalars['ID'];
  Int: Scalars['Int'];
  Query: {};
  SentMessage: SentMessage;
  SentMessage_filter: SentMessage_filter;
  String: Scalars['String'];
  Subscription: {};
  SyncCommitteeUpdate: SyncCommitteeUpdate;
  SyncCommitteeUpdate_filter: SyncCommitteeUpdate_filter;
  _Block_: _Block_;
  _Meta_: _Meta_;
}>;

export type entityDirectiveArgs = { };

export type entityDirectiveResolver<Result, Parent, ContextType = MeshContext & { subgraphName: string }, Args = entityDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type subgraphIdDirectiveArgs = {
  id: Scalars['String'];
};

export type subgraphIdDirectiveResolver<Result, Parent, ContextType = MeshContext & { subgraphName: string }, Args = subgraphIdDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type derivedFromDirectiveArgs = {
  field: Scalars['String'];
};

export type derivedFromDirectiveResolver<Result, Parent, ContextType = MeshContext & { subgraphName: string }, Args = derivedFromDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AllTimeSourceDataResolvers<ContextType = MeshContext & { subgraphName: string }, ParentType extends ResolversParentTypes['AllTimeSourceData'] = ResolversParentTypes['AllTimeSourceData']> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalSentMessages?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  totalSentBytes?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AllTimeTargetDataResolvers<ContextType = MeshContext & { subgraphName: string }, ParentType extends ResolversParentTypes['AllTimeTargetData'] = ResolversParentTypes['AllTimeTargetData']> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalReceivedMessages?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  totalReceivedBytes?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface BigDecimalScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BigDecimal'], any> {
  name: 'BigDecimal';
}

export interface BigIntScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['BigInt'], any> {
  name: 'BigInt';
}

export interface BytesScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Bytes'], any> {
  name: 'Bytes';
}

export type DailySourceDataResolvers<ContextType = MeshContext & { subgraphName: string }, ParentType extends ResolversParentTypes['DailySourceData'] = ResolversParentTypes['DailySourceData']> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dailySentMessages?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  dailySentBytes?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DailyTargetDataResolvers<ContextType = MeshContext & { subgraphName: string }, ParentType extends ResolversParentTypes['DailyTargetData'] = ResolversParentTypes['DailyTargetData']> = ResolversObject<{
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dailyReceivedMessages?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  dailyReceivedBytes?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ExecutedMessageResolvers<ContextType = MeshContext & { subgraphName: string }, ParentType extends ResolversParentTypes['ExecutedMessage'] = ResolversParentTypes['ExecutedMessage']> = ResolversObject<{
  id?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  msgHash?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  messageNonce?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  messageSenderChainID?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  messageSender?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  messageReceiverChainID?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  messageReceiver?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  messageData?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  transactionOrigin?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  blockNumber?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  blockTimestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  transactionHash?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type HeadUpdateResolvers<ContextType = MeshContext & { subgraphName: string }, ParentType extends ResolversParentTypes['HeadUpdate'] = ResolversParentTypes['HeadUpdate']> = ResolversObject<{
  id?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  slot?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  root?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  blockNumber?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  blockTimestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  transactionHash?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  transactionOrigin?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  address?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  chainId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type QueryResolvers<ContextType = MeshContext & { subgraphName: string }, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = ResolversObject<{
  sentMessage?: Resolver<Maybe<ResolversTypes['SentMessage']>, ParentType, ContextType, RequireFields<QuerysentMessageArgs, 'id' | 'subgraphError'>>;
  sentMessages?: Resolver<Array<ResolversTypes['SentMessage']>, ParentType, ContextType, RequireFields<QuerysentMessagesArgs, 'skip' | 'first' | 'subgraphError'>>;
  dailySourceData?: Resolver<Maybe<ResolversTypes['DailySourceData']>, ParentType, ContextType, RequireFields<QuerydailySourceDataArgs, 'id' | 'subgraphError'>>;
  dailySourceDatas?: Resolver<Array<ResolversTypes['DailySourceData']>, ParentType, ContextType, RequireFields<QuerydailySourceDatasArgs, 'skip' | 'first' | 'subgraphError'>>;
  allTimeSourceData?: Resolver<Maybe<ResolversTypes['AllTimeSourceData']>, ParentType, ContextType, RequireFields<QueryallTimeSourceDataArgs, 'id' | 'subgraphError'>>;
  allTimeSourceDatas?: Resolver<Array<ResolversTypes['AllTimeSourceData']>, ParentType, ContextType, RequireFields<QueryallTimeSourceDatasArgs, 'skip' | 'first' | 'subgraphError'>>;
  executedMessage?: Resolver<Maybe<ResolversTypes['ExecutedMessage']>, ParentType, ContextType, RequireFields<QueryexecutedMessageArgs, 'id' | 'subgraphError'>>;
  executedMessages?: Resolver<Array<ResolversTypes['ExecutedMessage']>, ParentType, ContextType, RequireFields<QueryexecutedMessagesArgs, 'skip' | 'first' | 'subgraphError'>>;
  dailyTargetData?: Resolver<Maybe<ResolversTypes['DailyTargetData']>, ParentType, ContextType, RequireFields<QuerydailyTargetDataArgs, 'id' | 'subgraphError'>>;
  dailyTargetDatas?: Resolver<Array<ResolversTypes['DailyTargetData']>, ParentType, ContextType, RequireFields<QuerydailyTargetDatasArgs, 'skip' | 'first' | 'subgraphError'>>;
  allTimeTargetData?: Resolver<Maybe<ResolversTypes['AllTimeTargetData']>, ParentType, ContextType, RequireFields<QueryallTimeTargetDataArgs, 'id' | 'subgraphError'>>;
  allTimeTargetDatas?: Resolver<Array<ResolversTypes['AllTimeTargetData']>, ParentType, ContextType, RequireFields<QueryallTimeTargetDatasArgs, 'skip' | 'first' | 'subgraphError'>>;
  headUpdate?: Resolver<Maybe<ResolversTypes['HeadUpdate']>, ParentType, ContextType, RequireFields<QueryheadUpdateArgs, 'id' | 'subgraphError'>>;
  headUpdates?: Resolver<Array<ResolversTypes['HeadUpdate']>, ParentType, ContextType, RequireFields<QueryheadUpdatesArgs, 'skip' | 'first' | 'subgraphError'>>;
  syncCommitteeUpdate?: Resolver<Maybe<ResolversTypes['SyncCommitteeUpdate']>, ParentType, ContextType, RequireFields<QuerysyncCommitteeUpdateArgs, 'id' | 'subgraphError'>>;
  syncCommitteeUpdates?: Resolver<Array<ResolversTypes['SyncCommitteeUpdate']>, ParentType, ContextType, RequireFields<QuerysyncCommitteeUpdatesArgs, 'skip' | 'first' | 'subgraphError'>>;
  _meta?: Resolver<Maybe<ResolversTypes['_Meta_']>, ParentType, ContextType, Partial<Query_metaArgs>>;
}>;

export type SentMessageResolvers<ContextType = MeshContext & { subgraphName: string }, ParentType extends ResolversParentTypes['SentMessage'] = ResolversParentTypes['SentMessage']> = ResolversObject<{
  id?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  msgHash?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  message?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  messageNonce?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  messageSenderChainID?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  messageSender?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  messageReceiverChainID?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  messageReceiver?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  messageData?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  transactionOrigin?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  blockNumber?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  blockTimestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  transactionHash?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SubscriptionResolvers<ContextType = MeshContext & { subgraphName: string }, ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']> = ResolversObject<{
  sentMessage?: SubscriptionResolver<Maybe<ResolversTypes['SentMessage']>, "sentMessage", ParentType, ContextType, RequireFields<SubscriptionsentMessageArgs, 'id' | 'subgraphError'>>;
  sentMessages?: SubscriptionResolver<Array<ResolversTypes['SentMessage']>, "sentMessages", ParentType, ContextType, RequireFields<SubscriptionsentMessagesArgs, 'skip' | 'first' | 'subgraphError'>>;
  dailySourceData?: SubscriptionResolver<Maybe<ResolversTypes['DailySourceData']>, "dailySourceData", ParentType, ContextType, RequireFields<SubscriptiondailySourceDataArgs, 'id' | 'subgraphError'>>;
  dailySourceDatas?: SubscriptionResolver<Array<ResolversTypes['DailySourceData']>, "dailySourceDatas", ParentType, ContextType, RequireFields<SubscriptiondailySourceDatasArgs, 'skip' | 'first' | 'subgraphError'>>;
  allTimeSourceData?: SubscriptionResolver<Maybe<ResolversTypes['AllTimeSourceData']>, "allTimeSourceData", ParentType, ContextType, RequireFields<SubscriptionallTimeSourceDataArgs, 'id' | 'subgraphError'>>;
  allTimeSourceDatas?: SubscriptionResolver<Array<ResolversTypes['AllTimeSourceData']>, "allTimeSourceDatas", ParentType, ContextType, RequireFields<SubscriptionallTimeSourceDatasArgs, 'skip' | 'first' | 'subgraphError'>>;
  executedMessage?: SubscriptionResolver<Maybe<ResolversTypes['ExecutedMessage']>, "executedMessage", ParentType, ContextType, RequireFields<SubscriptionexecutedMessageArgs, 'id' | 'subgraphError'>>;
  executedMessages?: SubscriptionResolver<Array<ResolversTypes['ExecutedMessage']>, "executedMessages", ParentType, ContextType, RequireFields<SubscriptionexecutedMessagesArgs, 'skip' | 'first' | 'subgraphError'>>;
  dailyTargetData?: SubscriptionResolver<Maybe<ResolversTypes['DailyTargetData']>, "dailyTargetData", ParentType, ContextType, RequireFields<SubscriptiondailyTargetDataArgs, 'id' | 'subgraphError'>>;
  dailyTargetDatas?: SubscriptionResolver<Array<ResolversTypes['DailyTargetData']>, "dailyTargetDatas", ParentType, ContextType, RequireFields<SubscriptiondailyTargetDatasArgs, 'skip' | 'first' | 'subgraphError'>>;
  allTimeTargetData?: SubscriptionResolver<Maybe<ResolversTypes['AllTimeTargetData']>, "allTimeTargetData", ParentType, ContextType, RequireFields<SubscriptionallTimeTargetDataArgs, 'id' | 'subgraphError'>>;
  allTimeTargetDatas?: SubscriptionResolver<Array<ResolversTypes['AllTimeTargetData']>, "allTimeTargetDatas", ParentType, ContextType, RequireFields<SubscriptionallTimeTargetDatasArgs, 'skip' | 'first' | 'subgraphError'>>;
  headUpdate?: SubscriptionResolver<Maybe<ResolversTypes['HeadUpdate']>, "headUpdate", ParentType, ContextType, RequireFields<SubscriptionheadUpdateArgs, 'id' | 'subgraphError'>>;
  headUpdates?: SubscriptionResolver<Array<ResolversTypes['HeadUpdate']>, "headUpdates", ParentType, ContextType, RequireFields<SubscriptionheadUpdatesArgs, 'skip' | 'first' | 'subgraphError'>>;
  syncCommitteeUpdate?: SubscriptionResolver<Maybe<ResolversTypes['SyncCommitteeUpdate']>, "syncCommitteeUpdate", ParentType, ContextType, RequireFields<SubscriptionsyncCommitteeUpdateArgs, 'id' | 'subgraphError'>>;
  syncCommitteeUpdates?: SubscriptionResolver<Array<ResolversTypes['SyncCommitteeUpdate']>, "syncCommitteeUpdates", ParentType, ContextType, RequireFields<SubscriptionsyncCommitteeUpdatesArgs, 'skip' | 'first' | 'subgraphError'>>;
  _meta?: SubscriptionResolver<Maybe<ResolversTypes['_Meta_']>, "_meta", ParentType, ContextType, Partial<Subscription_metaArgs>>;
}>;

export type SyncCommitteeUpdateResolvers<ContextType = MeshContext & { subgraphName: string }, ParentType extends ResolversParentTypes['SyncCommitteeUpdate'] = ResolversParentTypes['SyncCommitteeUpdate']> = ResolversObject<{
  id?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  period?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  root?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  blockNumber?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  blockTimestamp?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  transactionHash?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  transactionOrigin?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  address?: Resolver<ResolversTypes['Bytes'], ParentType, ContextType>;
  chainId?: Resolver<ResolversTypes['BigInt'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type _Block_Resolvers<ContextType = MeshContext & { subgraphName: string }, ParentType extends ResolversParentTypes['_Block_'] = ResolversParentTypes['_Block_']> = ResolversObject<{
  hash?: Resolver<Maybe<ResolversTypes['Bytes']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type _Meta_Resolvers<ContextType = MeshContext & { subgraphName: string }, ParentType extends ResolversParentTypes['_Meta_'] = ResolversParentTypes['_Meta_']> = ResolversObject<{
  block?: Resolver<ResolversTypes['_Block_'], ParentType, ContextType>;
  deployment?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  hasIndexingErrors?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = MeshContext & { subgraphName: string }> = ResolversObject<{
  AllTimeSourceData?: AllTimeSourceDataResolvers<ContextType>;
  AllTimeTargetData?: AllTimeTargetDataResolvers<ContextType>;
  BigDecimal?: GraphQLScalarType;
  BigInt?: GraphQLScalarType;
  Bytes?: GraphQLScalarType;
  DailySourceData?: DailySourceDataResolvers<ContextType>;
  DailyTargetData?: DailyTargetDataResolvers<ContextType>;
  ExecutedMessage?: ExecutedMessageResolvers<ContextType>;
  HeadUpdate?: HeadUpdateResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  SentMessage?: SentMessageResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  SyncCommitteeUpdate?: SyncCommitteeUpdateResolvers<ContextType>;
  _Block_?: _Block_Resolvers<ContextType>;
  _Meta_?: _Meta_Resolvers<ContextType>;
}>;

export type DirectiveResolvers<ContextType = MeshContext & { subgraphName: string }> = ResolversObject<{
  entity?: entityDirectiveResolver<any, any, ContextType>;
  subgraphId?: subgraphIdDirectiveResolver<any, any, ContextType>;
  derivedFrom?: derivedFromDirectiveResolver<any, any, ContextType>;
}>;

export type MeshContext = TelepathyRouterTypes.Context & BaseMeshContext;


import { fileURLToPath } from '@graphql-mesh/utils';
const baseDir = pathModule.join(pathModule.dirname(fileURLToPath(import.meta.url)), '..');

const importFn: ImportFn = <T>(moduleId: string) => {
  const relativeModuleId = (pathModule.isAbsolute(moduleId) ? pathModule.relative(baseDir, moduleId) : moduleId).split('\\').join('/').replace(baseDir + '/', '');
  switch(relativeModuleId) {
    case ".graphclient/sources/TelepathyRouter/introspectionSchema":
      return import("./sources/TelepathyRouter/introspectionSchema") as T;
    
    default:
      return Promise.reject(new Error(`Cannot find module '${relativeModuleId}'.`));
  }
};

const rootStore = new MeshStore('.graphclient', new FsStoreStorageAdapter({
  cwd: baseDir,
  importFn,
  fileType: "ts",
}), {
  readonly: true,
  validate: false
});

export const rawServeConfig: YamlConfig.Config['serve'] = undefined as any
export async function getMeshOptions(): Promise<GetMeshOptions> {
const pubsub = new PubSub();
const sourcesStore = rootStore.child('sources');
const logger = new DefaultLogger("GraphClient");
const cache = new (MeshCache as any)({
      ...({} as any),
      importFn,
      store: rootStore.child('cache'),
      pubsub,
      logger,
    } as any)

const sources: MeshResolvedSource[] = [];
const transforms: MeshTransform[] = [];
const additionalEnvelopPlugins: MeshPlugin<any>[] = [];
const telepathyRouterTransforms = [];
const additionalTypeDefs = [] as any[];
const telepathyRouterHandler = new GraphqlHandler({
              name: "TelepathyRouter",
              config: {"endpoint":"https://api.thegraph.com/subgraphs/name/{context.subgraphName:succinctlabs/telepathy-goerli}"},
              baseDir,
              cache,
              pubsub,
              store: sourcesStore.child("TelepathyRouter"),
              logger: logger.child("TelepathyRouter"),
              importFn,
            });
sources[0] = {
          name: 'TelepathyRouter',
          handler: telepathyRouterHandler,
          transforms: telepathyRouterTransforms
        }
const additionalResolvers = [] as any[]
const merger = new(BareMerger as any)({
        cache,
        pubsub,
        logger: logger.child('bareMerger'),
        store: rootStore.child('bareMerger')
      })

  return {
    sources,
    transforms,
    additionalTypeDefs,
    additionalResolvers,
    cache,
    pubsub,
    merger,
    logger,
    additionalEnvelopPlugins,
    get documents() {
      return [
      {
        document: GetSentMessageByMessageNumberDocument,
        get rawSDL() {
          return printWithCache(GetSentMessageByMessageNumberDocument);
        },
        location: 'GetSentMessageByMessageNumberDocument.graphql'
      },{
        document: GetSentMessageByTransactionHashDocument,
        get rawSDL() {
          return printWithCache(GetSentMessageByTransactionHashDocument);
        },
        location: 'GetSentMessageByTransactionHashDocument.graphql'
      },{
        document: GetSentMessageByMessageHashDocument,
        get rawSDL() {
          return printWithCache(GetSentMessageByMessageHashDocument);
        },
        location: 'GetSentMessageByMessageHashDocument.graphql'
      },{
        document: GetSentMessagesDocument,
        get rawSDL() {
          return printWithCache(GetSentMessagesDocument);
        },
        location: 'GetSentMessagesDocument.graphql'
      },{
        document: GetExecutedMessagesDocument,
        get rawSDL() {
          return printWithCache(GetExecutedMessagesDocument);
        },
        location: 'GetExecutedMessagesDocument.graphql'
      },{
        document: GetExecutedMessageByMessageNumberDocument,
        get rawSDL() {
          return printWithCache(GetExecutedMessageByMessageNumberDocument);
        },
        location: 'GetExecutedMessageByMessageNumberDocument.graphql'
      },{
        document: GetExecutedMessageByTransactionHashDocument,
        get rawSDL() {
          return printWithCache(GetExecutedMessageByTransactionHashDocument);
        },
        location: 'GetExecutedMessageByTransactionHashDocument.graphql'
      },{
        document: GetExecutedMessageByMessageHashDocument,
        get rawSDL() {
          return printWithCache(GetExecutedMessageByMessageHashDocument);
        },
        location: 'GetExecutedMessageByMessageHashDocument.graphql'
      },{
        document: GetRecentHeadUpdatesDocument,
        get rawSDL() {
          return printWithCache(GetRecentHeadUpdatesDocument);
        },
        location: 'GetRecentHeadUpdatesDocument.graphql'
      },{
        document: GetHeadUpdatesBeforeDocument,
        get rawSDL() {
          return printWithCache(GetHeadUpdatesBeforeDocument);
        },
        location: 'GetHeadUpdatesBeforeDocument.graphql'
      },{
        document: GetAllTimeSourceMetricsDocument,
        get rawSDL() {
          return printWithCache(GetAllTimeSourceMetricsDocument);
        },
        location: 'GetAllTimeSourceMetricsDocument.graphql'
      },{
        document: GetRecentSourceMetricsDocument,
        get rawSDL() {
          return printWithCache(GetRecentSourceMetricsDocument);
        },
        location: 'GetRecentSourceMetricsDocument.graphql'
      },{
        document: GetRecentDestinationMetricsDocument,
        get rawSDL() {
          return printWithCache(GetRecentDestinationMetricsDocument);
        },
        location: 'GetRecentDestinationMetricsDocument.graphql'
      }
    ];
    },
    fetchFn,
  };
}

export function createBuiltMeshHTTPHandler<TServerContext = {}>(): MeshHTTPHandler<TServerContext> {
  return createMeshHTTPHandler<TServerContext>({
    baseDir,
    getBuiltMesh: getBuiltGraphClient,
    rawServeConfig: undefined,
  })
}


let meshInstance$: Promise<MeshInstance> | undefined;

export function getBuiltGraphClient(): Promise<MeshInstance> {
  if (meshInstance$ == null) {
    meshInstance$ = getMeshOptions().then(meshOptions => getMesh(meshOptions)).then(mesh => {
      const id = mesh.pubsub.subscribe('destroy', () => {
        meshInstance$ = undefined;
        mesh.pubsub.unsubscribe(id);
      });
      return mesh;
    });
  }
  return meshInstance$;
}

export const execute: ExecuteMeshFn = (...args) => getBuiltGraphClient().then(({ execute }) => execute(...args));

export const subscribe: SubscribeMeshFn = (...args) => getBuiltGraphClient().then(({ subscribe }) => subscribe(...args));
export function getBuiltGraphSDK<TGlobalContext = any, TOperationContext = any>(globalContext?: TGlobalContext) {
  const sdkRequester$ = getBuiltGraphClient().then(({ sdkRequesterFactory }) => sdkRequesterFactory(globalContext));
  return getSdk<TOperationContext, TGlobalContext>((...args) => sdkRequester$.then(sdkRequester => sdkRequester(...args)));
}
export type GetSentMessageByMessageNumberQueryVariables = Exact<{
  num?: InputMaybe<Scalars['BigInt']>;
}>;


export type GetSentMessageByMessageNumberQuery = { sentMessages: Array<Pick<SentMessage, 'id' | 'version' | 'msgHash' | 'message' | 'messageData' | 'blockNumber' | 'blockTimestamp' | 'messageNonce' | 'messageReceiver' | 'messageReceiverChainID' | 'messageSender' | 'messageSenderChainID' | 'transactionHash' | 'transactionOrigin'>> };

export type GetSentMessageByTransactionHashQueryVariables = Exact<{
  hash?: InputMaybe<Scalars['Bytes']>;
}>;


export type GetSentMessageByTransactionHashQuery = { sentMessages: Array<Pick<SentMessage, 'id' | 'version' | 'msgHash' | 'message' | 'messageData' | 'blockNumber' | 'blockTimestamp' | 'messageNonce' | 'messageReceiver' | 'messageReceiverChainID' | 'messageSender' | 'messageSenderChainID' | 'transactionHash' | 'transactionOrigin'>> };

export type GetSentMessageByMessageHashQueryVariables = Exact<{
  hash?: InputMaybe<Scalars['Bytes']>;
}>;


export type GetSentMessageByMessageHashQuery = { sentMessages: Array<Pick<SentMessage, 'id' | 'version' | 'msgHash' | 'message' | 'messageData' | 'blockNumber' | 'blockTimestamp' | 'messageNonce' | 'messageReceiver' | 'messageReceiverChainID' | 'messageSender' | 'messageSenderChainID' | 'transactionHash' | 'transactionOrigin'>> };

export type GetSentMessagesQueryVariables = Exact<{
  where?: InputMaybe<SentMessage_filter>;
  skip?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['Int']>;
}>;


export type GetSentMessagesQuery = { sentMessages: Array<Pick<SentMessage, 'id' | 'version' | 'msgHash' | 'message' | 'messageData' | 'blockNumber' | 'blockTimestamp' | 'messageNonce' | 'messageReceiver' | 'messageReceiverChainID' | 'messageSender' | 'messageSenderChainID' | 'transactionHash' | 'transactionOrigin'>> };

export type GetExecutedMessagesQueryVariables = Exact<{
  where?: InputMaybe<ExecutedMessage_filter>;
  skip?: InputMaybe<Scalars['Int']>;
  count?: InputMaybe<Scalars['Int']>;
}>;


export type GetExecutedMessagesQuery = { executedMessages: Array<Pick<ExecutedMessage, 'id' | 'version' | 'msgHash' | 'message' | 'messageData' | 'blockNumber' | 'blockTimestamp' | 'messageNonce' | 'messageReceiver' | 'messageReceiverChainID' | 'messageSender' | 'messageSenderChainID' | 'transactionHash' | 'transactionOrigin' | 'status'>> };

export type GetExecutedMessageByMessageNumberQueryVariables = Exact<{
  num?: InputMaybe<Scalars['BigInt']>;
}>;


export type GetExecutedMessageByMessageNumberQuery = { executedMessages: Array<Pick<ExecutedMessage, 'id' | 'version' | 'msgHash' | 'message' | 'messageData' | 'blockNumber' | 'blockTimestamp' | 'messageNonce' | 'messageReceiver' | 'messageReceiverChainID' | 'messageSender' | 'messageSenderChainID' | 'transactionHash' | 'transactionOrigin' | 'status'>> };

export type GetExecutedMessageByTransactionHashQueryVariables = Exact<{
  hash?: InputMaybe<Scalars['Bytes']>;
}>;


export type GetExecutedMessageByTransactionHashQuery = { executedMessages: Array<Pick<ExecutedMessage, 'id' | 'version' | 'msgHash' | 'message' | 'messageData' | 'blockNumber' | 'blockTimestamp' | 'messageNonce' | 'messageReceiver' | 'messageReceiverChainID' | 'messageSender' | 'messageSenderChainID' | 'transactionHash' | 'transactionOrigin' | 'status'>> };

export type GetExecutedMessageByMessageHashQueryVariables = Exact<{
  hash?: InputMaybe<Scalars['Bytes']>;
}>;


export type GetExecutedMessageByMessageHashQuery = { executedMessages: Array<Pick<ExecutedMessage, 'id' | 'version' | 'msgHash' | 'message' | 'messageData' | 'blockNumber' | 'blockTimestamp' | 'messageNonce' | 'messageReceiver' | 'messageReceiverChainID' | 'messageSender' | 'messageSenderChainID' | 'transactionHash' | 'transactionOrigin' | 'status'>> };

export type GetRecentHeadUpdatesQueryVariables = Exact<{
  sourceChain?: InputMaybe<Scalars['BigInt']>;
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type GetRecentHeadUpdatesQuery = { headUpdates: Array<Pick<HeadUpdate, 'id' | 'slot' | 'root' | 'transactionHash' | 'transactionOrigin' | 'blockNumber' | 'blockTimestamp' | 'address' | 'chainId'>> };

export type GetHeadUpdatesBeforeQueryVariables = Exact<{
  sourceChain?: InputMaybe<Scalars['BigInt']>;
  blockNumber?: InputMaybe<Scalars['BigInt']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GetHeadUpdatesBeforeQuery = { headUpdates: Array<Pick<HeadUpdate, 'id' | 'slot' | 'root' | 'transactionHash' | 'transactionOrigin' | 'blockNumber' | 'blockTimestamp' | 'address' | 'chainId'>> };

export type GetAllTimeSourceMetricsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTimeSourceMetricsQuery = { allTimeSourceData?: Maybe<Pick<AllTimeSourceData, 'totalSentBytes' | 'totalSentMessages'>> };

export type GetRecentSourceMetricsQueryVariables = Exact<{
  count?: InputMaybe<Scalars['Int']>;
}>;


export type GetRecentSourceMetricsQuery = { dailySourceDatas: Array<Pick<DailySourceData, 'id' | 'dailySentBytes' | 'dailySentMessages'>> };

export type GetRecentDestinationMetricsQueryVariables = Exact<{
  count?: InputMaybe<Scalars['Int']>;
}>;


export type GetRecentDestinationMetricsQuery = { dailyTargetDatas: Array<Pick<DailyTargetData, 'id' | 'dailyReceivedBytes' | 'dailyReceivedMessages'>> };


export const GetSentMessageByMessageNumberDocument = gql`
    query GetSentMessageByMessageNumber($num: BigInt) {
  sentMessages(where: {messageNonce: $num}) {
    id
    version
    msgHash
    message
    messageData
    blockNumber
    blockTimestamp
    messageNonce
    messageReceiver
    messageReceiverChainID
    messageSender
    messageSenderChainID
    transactionHash
    transactionOrigin
  }
}
    ` as unknown as DocumentNode<GetSentMessageByMessageNumberQuery, GetSentMessageByMessageNumberQueryVariables>;
export const GetSentMessageByTransactionHashDocument = gql`
    query GetSentMessageByTransactionHash($hash: Bytes) {
  sentMessages(where: {transactionHash: $hash}) {
    id
    version
    msgHash
    message
    messageData
    blockNumber
    blockTimestamp
    messageNonce
    messageReceiver
    messageReceiverChainID
    messageSender
    messageSenderChainID
    transactionHash
    transactionOrigin
  }
}
    ` as unknown as DocumentNode<GetSentMessageByTransactionHashQuery, GetSentMessageByTransactionHashQueryVariables>;
export const GetSentMessageByMessageHashDocument = gql`
    query GetSentMessageByMessageHash($hash: Bytes) {
  sentMessages(where: {msgHash: $hash}) {
    id
    version
    msgHash
    message
    messageData
    blockNumber
    blockTimestamp
    messageNonce
    messageReceiver
    messageReceiverChainID
    messageSender
    messageSenderChainID
    transactionHash
    transactionOrigin
  }
}
    ` as unknown as DocumentNode<GetSentMessageByMessageHashQuery, GetSentMessageByMessageHashQueryVariables>;
export const GetSentMessagesDocument = gql`
    query GetSentMessages($where: SentMessage_filter, $skip: Int, $count: Int) {
  sentMessages(
    where: $where
    skip: $skip
    first: $count
    orderBy: messageNonce
    orderDirection: desc
  ) {
    id
    version
    msgHash
    message
    messageData
    blockNumber
    blockTimestamp
    messageNonce
    messageReceiver
    messageReceiverChainID
    messageSender
    messageSenderChainID
    transactionHash
    transactionOrigin
  }
}
    ` as unknown as DocumentNode<GetSentMessagesQuery, GetSentMessagesQueryVariables>;
export const GetExecutedMessagesDocument = gql`
    query GetExecutedMessages($where: ExecutedMessage_filter, $skip: Int, $count: Int) {
  executedMessages(
    where: $where
    skip: $skip
    first: $count
    orderBy: messageNonce
    orderDirection: desc
  ) {
    id
    version
    msgHash
    message
    messageData
    blockNumber
    blockTimestamp
    messageNonce
    messageReceiver
    messageReceiverChainID
    messageSender
    messageSenderChainID
    transactionHash
    transactionOrigin
    status
  }
}
    ` as unknown as DocumentNode<GetExecutedMessagesQuery, GetExecutedMessagesQueryVariables>;
export const GetExecutedMessageByMessageNumberDocument = gql`
    query GetExecutedMessageByMessageNumber($num: BigInt) {
  executedMessages(where: {messageNonce: $num}) {
    id
    version
    msgHash
    message
    messageData
    blockNumber
    blockTimestamp
    messageNonce
    messageReceiver
    messageReceiverChainID
    messageSender
    messageSenderChainID
    transactionHash
    transactionOrigin
    status
  }
}
    ` as unknown as DocumentNode<GetExecutedMessageByMessageNumberQuery, GetExecutedMessageByMessageNumberQueryVariables>;
export const GetExecutedMessageByTransactionHashDocument = gql`
    query GetExecutedMessageByTransactionHash($hash: Bytes) {
  executedMessages(where: {transactionHash: $hash}) {
    id
    version
    msgHash
    message
    messageData
    blockNumber
    blockTimestamp
    messageNonce
    messageReceiver
    messageReceiverChainID
    messageSender
    messageSenderChainID
    transactionHash
    transactionOrigin
    status
  }
}
    ` as unknown as DocumentNode<GetExecutedMessageByTransactionHashQuery, GetExecutedMessageByTransactionHashQueryVariables>;
export const GetExecutedMessageByMessageHashDocument = gql`
    query GetExecutedMessageByMessageHash($hash: Bytes) {
  executedMessages(where: {msgHash: $hash}) {
    id
    version
    msgHash
    message
    messageData
    blockNumber
    blockTimestamp
    messageNonce
    messageReceiver
    messageReceiverChainID
    messageSender
    messageSenderChainID
    transactionHash
    transactionOrigin
    status
  }
}
    ` as unknown as DocumentNode<GetExecutedMessageByMessageHashQuery, GetExecutedMessageByMessageHashQueryVariables>;
export const GetRecentHeadUpdatesDocument = gql`
    query GetRecentHeadUpdates($sourceChain: BigInt, $first: Int, $skip: Int) {
  headUpdates(
    where: {chainId: $sourceChain}
    orderBy: blockTimestamp
    orderDirection: desc
    first: $first
    skip: $skip
  ) {
    id
    slot
    root
    transactionHash
    transactionOrigin
    blockNumber
    blockTimestamp
    address
    chainId
  }
}
    ` as unknown as DocumentNode<GetRecentHeadUpdatesQuery, GetRecentHeadUpdatesQueryVariables>;
export const GetHeadUpdatesBeforeDocument = gql`
    query GetHeadUpdatesBefore($sourceChain: BigInt, $blockNumber: BigInt, $first: Int) {
  headUpdates(
    orderBy: blockTimestamp
    orderDirection: desc
    where: {blockNumber_lt: $blockNumber, chainId: $sourceChain}
    first: $first
  ) {
    id
    slot
    root
    transactionHash
    transactionOrigin
    blockNumber
    blockTimestamp
    address
    chainId
  }
}
    ` as unknown as DocumentNode<GetHeadUpdatesBeforeQuery, GetHeadUpdatesBeforeQueryVariables>;
export const GetAllTimeSourceMetricsDocument = gql`
    query GetAllTimeSourceMetrics {
  allTimeSourceData(id: "0") {
    totalSentBytes
    totalSentMessages
  }
}
    ` as unknown as DocumentNode<GetAllTimeSourceMetricsQuery, GetAllTimeSourceMetricsQueryVariables>;
export const GetRecentSourceMetricsDocument = gql`
    query GetRecentSourceMetrics($count: Int) {
  dailySourceDatas(first: $count, orderBy: id, orderDirection: desc) {
    id
    dailySentBytes
    dailySentMessages
  }
}
    ` as unknown as DocumentNode<GetRecentSourceMetricsQuery, GetRecentSourceMetricsQueryVariables>;
export const GetRecentDestinationMetricsDocument = gql`
    query GetRecentDestinationMetrics($count: Int) {
  dailyTargetDatas(first: $count, orderBy: id, orderDirection: desc) {
    id
    dailyReceivedBytes
    dailyReceivedMessages
  }
}
    ` as unknown as DocumentNode<GetRecentDestinationMetricsQuery, GetRecentDestinationMetricsQueryVariables>;














export type Requester<C = {}, E = unknown> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R> | AsyncIterable<R>
export function getSdk<C, E>(requester: Requester<C, E>) {
  return {
    GetSentMessageByMessageNumber(variables?: GetSentMessageByMessageNumberQueryVariables, options?: C): Promise<GetSentMessageByMessageNumberQuery> {
      return requester<GetSentMessageByMessageNumberQuery, GetSentMessageByMessageNumberQueryVariables>(GetSentMessageByMessageNumberDocument, variables, options) as Promise<GetSentMessageByMessageNumberQuery>;
    },
    GetSentMessageByTransactionHash(variables?: GetSentMessageByTransactionHashQueryVariables, options?: C): Promise<GetSentMessageByTransactionHashQuery> {
      return requester<GetSentMessageByTransactionHashQuery, GetSentMessageByTransactionHashQueryVariables>(GetSentMessageByTransactionHashDocument, variables, options) as Promise<GetSentMessageByTransactionHashQuery>;
    },
    GetSentMessageByMessageHash(variables?: GetSentMessageByMessageHashQueryVariables, options?: C): Promise<GetSentMessageByMessageHashQuery> {
      return requester<GetSentMessageByMessageHashQuery, GetSentMessageByMessageHashQueryVariables>(GetSentMessageByMessageHashDocument, variables, options) as Promise<GetSentMessageByMessageHashQuery>;
    },
    GetSentMessages(variables?: GetSentMessagesQueryVariables, options?: C): Promise<GetSentMessagesQuery> {
      return requester<GetSentMessagesQuery, GetSentMessagesQueryVariables>(GetSentMessagesDocument, variables, options) as Promise<GetSentMessagesQuery>;
    },
    GetExecutedMessages(variables?: GetExecutedMessagesQueryVariables, options?: C): Promise<GetExecutedMessagesQuery> {
      return requester<GetExecutedMessagesQuery, GetExecutedMessagesQueryVariables>(GetExecutedMessagesDocument, variables, options) as Promise<GetExecutedMessagesQuery>;
    },
    GetExecutedMessageByMessageNumber(variables?: GetExecutedMessageByMessageNumberQueryVariables, options?: C): Promise<GetExecutedMessageByMessageNumberQuery> {
      return requester<GetExecutedMessageByMessageNumberQuery, GetExecutedMessageByMessageNumberQueryVariables>(GetExecutedMessageByMessageNumberDocument, variables, options) as Promise<GetExecutedMessageByMessageNumberQuery>;
    },
    GetExecutedMessageByTransactionHash(variables?: GetExecutedMessageByTransactionHashQueryVariables, options?: C): Promise<GetExecutedMessageByTransactionHashQuery> {
      return requester<GetExecutedMessageByTransactionHashQuery, GetExecutedMessageByTransactionHashQueryVariables>(GetExecutedMessageByTransactionHashDocument, variables, options) as Promise<GetExecutedMessageByTransactionHashQuery>;
    },
    GetExecutedMessageByMessageHash(variables?: GetExecutedMessageByMessageHashQueryVariables, options?: C): Promise<GetExecutedMessageByMessageHashQuery> {
      return requester<GetExecutedMessageByMessageHashQuery, GetExecutedMessageByMessageHashQueryVariables>(GetExecutedMessageByMessageHashDocument, variables, options) as Promise<GetExecutedMessageByMessageHashQuery>;
    },
    GetRecentHeadUpdates(variables?: GetRecentHeadUpdatesQueryVariables, options?: C): Promise<GetRecentHeadUpdatesQuery> {
      return requester<GetRecentHeadUpdatesQuery, GetRecentHeadUpdatesQueryVariables>(GetRecentHeadUpdatesDocument, variables, options) as Promise<GetRecentHeadUpdatesQuery>;
    },
    GetHeadUpdatesBefore(variables?: GetHeadUpdatesBeforeQueryVariables, options?: C): Promise<GetHeadUpdatesBeforeQuery> {
      return requester<GetHeadUpdatesBeforeQuery, GetHeadUpdatesBeforeQueryVariables>(GetHeadUpdatesBeforeDocument, variables, options) as Promise<GetHeadUpdatesBeforeQuery>;
    },
    GetAllTimeSourceMetrics(variables?: GetAllTimeSourceMetricsQueryVariables, options?: C): Promise<GetAllTimeSourceMetricsQuery> {
      return requester<GetAllTimeSourceMetricsQuery, GetAllTimeSourceMetricsQueryVariables>(GetAllTimeSourceMetricsDocument, variables, options) as Promise<GetAllTimeSourceMetricsQuery>;
    },
    GetRecentSourceMetrics(variables?: GetRecentSourceMetricsQueryVariables, options?: C): Promise<GetRecentSourceMetricsQuery> {
      return requester<GetRecentSourceMetricsQuery, GetRecentSourceMetricsQueryVariables>(GetRecentSourceMetricsDocument, variables, options) as Promise<GetRecentSourceMetricsQuery>;
    },
    GetRecentDestinationMetrics(variables?: GetRecentDestinationMetricsQueryVariables, options?: C): Promise<GetRecentDestinationMetricsQuery> {
      return requester<GetRecentDestinationMetricsQuery, GetRecentDestinationMetricsQueryVariables>(GetRecentDestinationMetricsDocument, variables, options) as Promise<GetRecentDestinationMetricsQuery>;
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;